// extracted by mini-css-extract-plugin
module.exports = {"loaderDots":"BetterLoader_loaderDots__2aFUu","sk-bouncedelay":"BetterLoader_sk-bouncedelay__1aR94","bounce1":"BetterLoader_bounce1__1Rtl8","bounce2":"BetterLoader_bounce2__1nchq"};